import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ArchiveTrafficReport, TrafficReport } from '../common/models/traffic-report';
import { RemainingTraffic } from '../common/models/remaining-traffic';

@Injectable({
  providedIn: 'root'
})
export class TrafficService {

  baseApi = environment.baseCloud7CmsApiUrl + '/api';

  constructor(private http: HttpClient) {}

 

  getTraffics(
    operator: string,
    merchant: string,
    source: string = 'live'
  ) {
 

    let params = new HttpParams(); 
    params = params.append('source', source);

    const headers = this.getOperatorHeader(operator);
    return this.http.get< TrafficReport[]>(
      this.baseApi + '/Traffic/' + merchant,
      { headers: headers, params: params }
    );
  }

  getArchiveTraffics(
    operator: string,
    merchant: string, fromDate : Date,toDate : Date ) {
 

    let params = new HttpParams(); 
    params = params.append('fromDate', fromDate.toDateString());
    params = params.append('toDate', toDate.toDateString());

    const headers = this.getOperatorHeader(operator);
    return this.http.get<TrafficReport[]>(
      this.baseApi + '/Traffic/' + merchant + '/archive',
      { headers: headers, params: params }
    );
  }

  getRemainingTrafficCount(
    operator: string,
    merchant: string 
  ) { 
    let params = new HttpParams();  

    const headers = this.getOperatorHeader(operator);
    return this.http.get<RemainingTraffic>(
      this.baseApi + '/Traffic/' + merchant + '/remaining_traffic',
      { headers: headers, params: params }
    );
  }

  
  private getOperatorHeader(operator: string) {
    const headers = new HttpHeaders({ Operator: operator });
    return headers;
  }
}
